import { IMerchantSettings } from '@entities/merchant';

export const MERCHANT_SETTINGS_KEYS: (keyof IMerchantSettings)[] = [
  'is_priority',
  'denied_withdraw_with_negative_balance',
  'deviation',
  'threshold',
  'metabase_analytics_dashboard_id',
  'support_slip_upload',
  'wallet_routing_enabled',
];

export const assmebleMerchantSettings = (fd: FormData) => {
  return MERCHANT_SETTINGS_KEYS.reduce((acc, key) => {
    switch (key) {
      case 'is_priority':
        acc[key] = fd.get(key) === 'true';
        break;
      case 'deviation':
      case 'threshold':
        acc[key] = fd.get(key) ? String(fd.get(key)) : '0';
        break;
      case 'metabase_analytics_dashboard_id':
        acc[key] = fd.get(key) ? Number(fd.get(key)) : 0;
        break;
      default:
        acc[key] = fd.get(key) === 'true';
    }
    return acc;
  }, {} as IMerchantSettings);
};
